import { render } from "./Main.vue?vue&type=template&id=19f413ec"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=19f413ec&lang=css"

import exportComponent from "/Users/amane/Documents/-4°/AmaneStudio/A++/Amane.dev/amane_dev/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__